export const environment = {
  name: 'dev',
  production: false,
  apiUrl: 'https://admin-backend-dev.obiserver.hu/api'
};
